/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { UserRoles } from './user';

export enum SurveyUserRoles {
  Admin = 'admin',
  Verifier = 'verifier',
  Stakeholder = 'stakeholder',
  Monitor = 'viewer'
}

export interface UserMin {
  _id: string;
  firstName?: string;
  surname?: string;
  profile?: string;
  active?: boolean;
  jobTitle?: string; // Not on api UserMin?
  roles?: string[]; // Not on api UserMin?
  company?: string; // Not on api UserMin?
  contact?: string; // Not on api UserMin?
}

export interface UserPermissions {
  permissions: UserRoles[];
  initiativeId: string;
}

export interface SafeUser extends UserMin {
  title: string;
  name?: string;
  stakeholderTypes: string[];
  partnerTypes?: string;
  lastLogin?: string;
  active: boolean;
  permissions: UserPermissions[];
  isStaff?: boolean;
  email?: string;
}
